import DcTable from "./DcTable";

export default DcTable;
